import React from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
  ListItemIcon,
  IconButton,
  Divider,
} from "@mui/material";
import {
  DashboardOutlined,
  MenuBookOutlined,
  AccountCircleOutlined,
  GradeOutlined,
  ExitToAppOutlined,
} from "@mui/icons-material";
import { styled } from "@mui/system";
import { alpha } from "@mui/material/styles";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const LogoutButton = styled(IconButton)(({ theme }) => ({
  color: theme?.palette?.error?.main || "#E1BA66",
  textTransform: "none",
  "&:hover": {
    backgroundColor: alpha(theme?.palette?.error?.main || "#E1BA66", 0.08),
  },
}));

const handleLogout = () => {
  localStorage.clear();
  window.location.reload();
};

const drawerWidth = 210;

const LeftSidebar = ({ currentScreen, setCurrentScreen }) => {
  return (
    <div style={{ display: "flex" }}>
      {/* Sidebar / Drawer */}
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            bgcolor: "#000",
            color: "#E1BA66",
            border: "none",
            padding: "0px 15px",
            transition: "0.3s",
          },
        }}
      >
        {/* Logo */}
        <Box sx={{ textAlign: "center", marginBottom: 3, marginTop: 5 }}>
          {/* <img
            src={require("../assets/coloredLogo.png")}
            alt="Logo"
            style={{ height: 50, marginBottom: 15, width: 150, marginTop: -23 ,background:"#E1BA66", padding:"0.5rem"}}
          /> */}
          <div className="d-flex text-white align-items-center">
            <img
              src={require("../assets/FLP_Logo_500 x 500.png")}
              alt="Login"
              style={{ width: "63%", height: "auto" }}
            />
            <p
              style={{
                fontSize: "15px",
                fontWeight: "bold",
                textAlign: "left",
                // textTransform: "uppercase",
                wordSpacing: "3px",
                color: "#c2a160",
              }}
            >
              Financial Literacy Program
            </p>
          </div>
        </Box>

        {/* Sidebar Items */}

        <List>
          {/* Dashboard */}
          <ListItem
            button
            onClick={() => setCurrentScreen(10)}
            selected={currentScreen === 10}
            sx={{
              "&.Mui-selected, &:hover": {
                bgcolor: "#E1BA66",
                color: "white",
                borderRadius: "3px",
              },
              "&:hover": { bgcolor: "#E1BA66" },
              mb: 0.4,
              p: 1.2,
              borderRadius: "3px",
            }}
          >
            <ListItemIcon sx={{ color: "#fff", minWidth: 36 }}>
              <DashboardOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary="Dashboard"
              primaryTypographyProps={{
                fontSize: 15,
                sx: { "&:hover": { color: "#fff" } },
              }}
            />
          </ListItem>

          {/* Courses */}
          <ListItem
            button
            onClick={() => setCurrentScreen(0)}
            selected={currentScreen === 0}
            sx={{
              "&.Mui-selected, &:hover": {
                bgcolor: "#E1BA66",
                color: "white",
                borderRadius: "3px",
              },
              "&:hover": { bgcolor: "#E1BA66" },
              mb: 0.4,
              p: 1.2,
              borderRadius: "3px",
            }}
          >
            <ListItemIcon sx={{ color: "#fff", minWidth: 36 }}>
              <MenuBookOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary="Courses"
              primaryTypographyProps={{
                fontSize: 15,
                sx: { "&:hover": { color: "#fff" } },
              }}
            />
          </ListItem>

          {/* Grades */}
          <ListItem
            button
            onClick={() => setCurrentScreen(8)}
            selected={currentScreen === 8}
            sx={{
              "&.Mui-selected, &:hover": {
                bgcolor: "#E1BA66",
                color: "white",
                borderRadius: "3px",
              },
              "&:hover": { bgcolor: "#E1BA66" },
              mb: 2,
              p: 1.2,
              borderRadius: "3px",
            }}
          >
            <ListItemIcon sx={{ color: "#fff", minWidth: 36 }}>
              <GradeOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary="Grades"
              primaryTypographyProps={{
                fontSize: 15,
                sx: { "&:hover": { color: "#fff" } },
              }}
            />
          </ListItem>

          {/* Profile */}
          <ListItem
            button
            onClick={() => setCurrentScreen(7)}
            selected={currentScreen === 7}
            sx={{
              "&.Mui-selected, &:hover": {
                bgcolor: "#E1BA66",
                color: "white",
                borderRadius: "3px",
              },
              "&:hover": { bgcolor: "#E1BA66" },
              mb: 0.4,
              p: 1.2,
              borderRadius: "3px",
            }}
          >
            <ListItemIcon sx={{ color: "#fff", minWidth: 36 }}>
              <AccountCircleOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary="Profile"
              primaryTypographyProps={{
                fontSize: 15,
                sx: { "&:hover": { color: "#fff" } },
              }}
            />
          </ListItem>
        </List>

        {/* Query Item For Employee */}
        {/* <ListItem
          button
          onClick={() => setCurrentScreen(5)}
          selected={currentScreen === 5}
          sx={{
            "&.Mui-selected, &:hover": {
              bgcolor: "#E1BA66",
              color: "white",
              borderRadius: "3px",
            },
            "&:hover": { bgcolor: "#E1BA66" },
            mb: 0.4,
            p: 1.2,
            borderRadius: "3px",
          }}
        >
          <ListItemIcon sx={{ color: "#fff", minWidth: 36 }}>
            <HelpOutlineIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="My Queries"
            primaryTypographyProps={{
              fontSize: 15,
              sx: { "&:hover": { color: "#fff" } },
            }}
          />
        </ListItem> */}

        <Divider sx={{ my: 2, bgcolor: "#E1BA66" }} />

        {/* Logout Button */}
        <Box sx={{ textAlign: "center" }}>
          <LogoutButton
            onClick={handleLogout}
            sx={{
              width: "100%",
              py: 1.5,
              borderRadius: 2,
              color: "#E1BA66",
            }}
          >
            <ExitToAppOutlined fontSize="small" sx={{ mr: 1 }} />
            Logout
          </LogoutButton>
        </Box>
      </Drawer>
    </div>
  );
};

export default LeftSidebar;
